import React from "react";

interface CardProps {
  children: React.ReactNode;
  heading: string;
  isSingleColumn?: boolean;
  className?: string;
}

const DividerCard: React.FC<CardProps> = ({
  children,
  heading,
  isSingleColumn = false,
  className = "",
}) => {
  return (
    <div
      className={
        className
          ? `w-full mx-auto sm:max-w-7xl rounded-2xl bg-gray-100 p-4 shadow-md ${className}`
          : "w-full mx-auto sm:max-w-7xl rounded-2xl bg-gray-100 p-4 shadow-md"
      }
    >
      <h2 className="text-blue_royal p-5 text-lg sm:text-xl md:text-2xl font-bold text-center">
        {heading}
      </h2>
      <div
        className={`grid gap-4 items-center ${
          isSingleColumn ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-3"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default DividerCard;
